import {
  PsychologistSearchListData,
  PsychologistSearchListDataResponse,
} from './PsychologistSearchListDataMapper.types'

class PsychologistSearchListDataMapper {
  toDomain(
    persistenceData: PsychologistSearchListDataResponse,
  ): PsychologistSearchListData {
    return {
      id: persistenceData?.idPsicologo,
      name: persistenceData?.psicologo?.nome,
      crp: `${persistenceData?.psicologo?.crp} ${persistenceData?.psicologo?.estadoCrp}`,
      specialty: persistenceData?.psicologo?.nomeEspecialidade,
    }
  }
}

export default new PsychologistSearchListDataMapper()
